import { createFileRoute } from '@tanstack/react-router';
import NewPasswordPage from '@/pages/reset-password/new-password/index.page';
import { parseNewPasswordSearch } from '@/pages/reset-password/new-password/utils/new-password-search';
import { warnMissingToken } from '@/pages/reset-password/new-password/utils/warn-missing-token';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

function NewPasswordRoute() {
  const search = Route.useSearch();
  return <NewPasswordPage search={search} />;
}

// Where the reset and invite emails land.
export const Route = createFileRoute('/reset_password/new_password')({
  validateSearch: parseNewPasswordSearch,
  onEnter: ({ search }) => warnMissingToken(search),
  component: withRumPageRendered(NewPasswordRoute),
});
